import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationCondicaoPagamento } from '../integration-condicao-pagamento';

@Injectable({
    providedIn: 'root'
})
export class IntegrationCondicaoPagamentoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/condicaopagamento`;
    }

    /** Executa a integração de leitura das condições de pagamentos com os sistemas ERP's */
    execReadIntegration(entity: IntegrationCondicaoPagamento): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(this.pathApi, null, {params, responseType: 'text'});
    }
}
